export const messagePlatform = {
    "btns":{
        "createNewMessage":  "Crear nuevo mensaje",
        "sendMessage":  "Enviar mensaje",
        "privateName": "Nombre privado",
        "buildingAddress": "Dirección del Edificio",
        "apartmentNumber": "Número de Apartamento",
        "paymentLink": "Enlace de Pago",
        "sms": "SMS",
        "email": "Email",
        "chooseTenants": "Elegir inquilinos",
        "owners": "Propietarios",
        "renters": "Inquilinos"
    },
    "labels": {
        "smsMessageContent": "Contenido del SMS mensaje",
        "emailMessageContent": "Contenido del Email mensaje",
        "chooseMethod": "Contenido del mensaje",
        "senderName": "Nombre del remitente",
        "remainingMessages": "Saldo mensual de mensajes",
        "personalizedContent": "Contenido personalizado",
        "contact": "Contactos para enviar",
        "apartment": "Apartmento",
        "selection": "Seleccionar",
        "selectAll": "Seleccionar todo"
    },
    "titles": {
        "messagePlatform": "Plataforma de mensajes",
        "sendMessage": "Enviar un mensaje",
    },
    "messages":{
        "successSending": "mensajes enviados con éxito a {{numberOfTenants}} inquilinos"
    }
};
